<app-header></app-header>

<div class="mentions-legales-page">
  <div class="container">
    <!-- En-tête -->
    <div class="header-section">
      <h1 class="main-title">Mentions légales et CGU</h1>
      <p class="subtitle">Site pdf-to-word.fr</p>
    </div>

    <!-- Informations de l'entreprise -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">Informations légales</h2>
        
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">Raison sociale et forme sociale :</span>
            <span class="info-value">SBDI</span>
          </div>
          
          <div class="info-item">
            <span class="info-label">Siège social :</span>
            <span class="info-value">2a Connaught Avenue, London, United Kingdom, E4 7AA</span>
          </div>
          
          <div class="info-item">
            <span class="info-label">Numéro BRN :</span>
            <span class="info-value">16129808</span>
          </div>
          
          <div class="info-item">
            <span class="info-label">Adresse email :</span>
            <span class="info-value">{{ supportEmail }}</span>
          </div>
          
          <div class="info-item">
            <span class="info-label">Responsable de la publication :</span>
            <span class="info-value">M. David Zacchara</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Informations de l'hébergeur -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">Informations de l'hébergeur</h2>
        
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">Nom de l'hébergeur :</span>
            <span class="info-value">Agence des media Numériques (AMEN)</span>
          </div>
          
          <div class="info-item">
            <span class="info-label">Forme sociale :</span>
            <span class="info-value">SASU 42152779700011</span>
          </div>
          
          <div class="info-item">
            <span class="info-label">Siège social :</span>
            <span class="info-value">12 à 14 Chez Regus, 12 rond point des Champs Elysées M. Dassault</span>
          </div>
          
          <div class="info-item">
            <span class="info-label">Nom du responsable de traitement :</span>
            <span class="info-value">SBDI</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Données personnelles -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">Données à caractère personnel</h2>
        
        <div class="content-text">
          <p>Conformément à la loi Informatique et Libertés n° 78-17 du 6 janvier 1978, modifiée par la loi n°2004-801 du 6 août 2004, les traitements mis en œuvre sur ce site ont fait l'objet d'une déclaration auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL), qui en a délivré récépissé sous le numéro ci-dessus indiqué.</p>
          
          <p>Les données à caractère personnel vous concernant que nous pourrions être amenés à recueillir sont collectées aux conditions indiquées dans les rubriques « Conditions générales d'utilisation du site » et « Utilisation des données à caractère personnel ».</p>
          
          <p>Vous disposez d'un droit d'accès, de modification, de rectification et de suppression des données à caractère personnel que nous pourrions être amenés à collecter.</p>
          
          <div class="action-link">
            <a href="/supprimer-mes-donnees-personnelles" class="btn-primary">Pour l'exercer : Cliquez ici</a>
          </div>
        </div>
      </div>
    </div>

    <!-- Horaires et contact -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">Horaires et contact</h2>
        
        <div class="contact-info">
          <div class="schedule">
            <h3 class="subsection-title">Horaires</h3>
            <p>Du lundi au vendredi de 9h à 12h et de 13h à 18h</p>
          </div>
          
          <div class="customer-service">
            <h3 class="subsection-title">Service client</h3>
            <p>Notre service client se tient à votre disposition, de 9h à 12h et de 13h à 18h du lundi au vendredi, au numéro suivant:</p>
            <div class="phone-number">
              <span class="phone">0 532 183 976</span>
              <span class="phone-details">Service gratuit + prix appel</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Cookies -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">Cookies</h2>
        
        <div class="content-text">
          <p>Pour une expérience optimale lors de votre visite, nous utilisons des cookies.</p>
          
          <p>Ces cookies améliorent votre expérience sur notre site et garantissent le fonctionnement optimal de notre site tout en protégeant vos données.</p>
          
          <p>En continuant à naviguer sur notre site, vous acceptez l'utilisation de ces cookies selon notre politique en matière de confidentialité.</p>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>